"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DB_TZ = exports.NOTIFY_INTERVAL_HOURS = exports.emptyFilters = exports.RangeType = exports.FilterStatus = exports.Precision = void 0;
var Precision;
(function (Precision) {
    Precision["hour"] = "hour";
    Precision["day"] = "day";
    Precision["month"] = "month";
})(Precision || (exports.Precision = Precision = {}));
var FilterStatus;
(function (FilterStatus) {
    FilterStatus["all"] = "all";
    FilterStatus["nonWarning"] = "nonWarning";
    FilterStatus["warning"] = "warning";
})(FilterStatus || (exports.FilterStatus = FilterStatus = {}));
var RangeType;
(function (RangeType) {
    RangeType["WORK_DAY"] = "WORK_DAY";
    RangeType["FULL_DAY"] = "FULL_DAY";
    RangeType["WEEK"] = "WEEK";
    RangeType["MONTH"] = "MONTH";
    RangeType["YEAR"] = "YEAR";
    RangeType["SELECTED_RANGE"] = "SELECTED_RANGE";
    RangeType["RECORDER_MODE"] = "RECORDER_MODE";
})(RangeType || (exports.RangeType = RangeType = {}));
exports.emptyFilters = {
    equipmentGroup: 0,
    instanceNumber: "",
    manufacturer: 0,
    path: 0,
    rfid: "",
    technologicalProcess: 0,
    trainName: "",
    trainPosition: "",
    trainSerial: "",
    trainType: 0,
};
exports.NOTIFY_INTERVAL_HOURS = 12;
exports.DB_TZ = 180;
//# sourceMappingURL=interfaces.js.map